// extracted by mini-css-extract-plugin
export default {"termsOfServiceContainer":"TermsOfService_termsOfServiceContainer__iHYTn","iframe":"TermsOfService_iframe__TXb8c","accept_container":"TermsOfService_accept_container__SQaUL"};